import app from '../app';
/**
 * An icon image being edited in a form: a file chosen to upload, or the
 * removal of the current image. Nothing is sent until `save()`, so a form can
 * create its model first and upload the image to it afterwards.
 */
export default class IconImageState {
  /** A file to upload, null to remove the current image, undefined to leave it. */
  change = (() => undefined)();
  objectUrl = null;
  constructor(model) {
    this.model = model;
  }

  /** The image to preview: the chosen file, or the model's current image. */
  url() {
    if (this.change === undefined) return this.model.iconImageUrl() || null;
    return this.objectUrl;
  }
  srcset() {
    return this.change === undefined ? this.model.iconImageSrcset() || null : null;
  }
  isDirty() {
    return this.change !== undefined;
  }
  set(file) {
    this.revokeObjectUrl();
    this.change = file;
    this.objectUrl = URL.createObjectURL(file);
  }
  remove() {
    this.revokeObjectUrl();
    this.change = this.model.iconImageUrl() ? null : undefined;
  }

  /**
   * Upload or remove the image. Pass the model a new record was saved as: a
   * new record's save resolves to another instance.
   */
  async save(model, options) {
    if (model === void 0) {
      model = this.model;
    }
    if (options === void 0) {
      options = {};
    }
    this.model = model;
    if (this.change === undefined) return;
    const url = `${app.forum.attribute('apiUrl')}/${model.data.type}/${model.id()}/icon-image`;
    let payload;
    if (this.change === null) {
      payload = await app.request({
        ...options,
        method: 'DELETE',
        url
      });
    } else {
      const body = new FormData();
      body.append('iconImage', this.change);
      payload = await app.request({
        ...options,
        method: 'POST',
        url,
        serialize: raw => raw,
        body
      });
    }
    app.store.pushPayload(payload);
    this.revokeObjectUrl();
    this.change = undefined;
  }

  /** Release the chosen file's preview. Call when the form closes. */
  dispose() {
    this.revokeObjectUrl();
  }
  revokeObjectUrl() {
    if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
    this.objectUrl = null;
  }
}
flarum.reg.add('core', 'common/states/IconImageState', IconImageState);